import { createContext, useContext } from "solid-js";
export const SolidNodeViewContext = createContext({
    onDragStart: undefined,
});
export const useSolidNodeView = () => useContext(SolidNodeViewContext);
